/**
 * Kürzel eines Postfachs für den Kreis im Oval und im Seitenmenü (wie Outlook
 * iOS die Konten als Kreise zeigt): aus dem Anzeigenamen Vor- und Nachname,
 * ohne Namen der Anfang der Adresse.
 */
export function postfachKuerzel(name: string | null | undefined, adresse: string | null | undefined): string {
    const teile = (name ?? "")
        .replace(/[^\p{L}\p{N}\s-]/gu, " ")
        .split(/[\s-]+/)
        .filter(Boolean);
    if (teile.length >= 2) return (teile[0][0] + teile[teile.length - 1][0]).toUpperCase();
    if (teile.length === 1) return teile[0].slice(0, 2).toUpperCase();
    const lokal = (adresse ?? "").split("@")[0].replace(/[^\p{L}\p{N}]/gu, "");
    return lokal ? lokal.slice(0, 2).toUpperCase() : "?";
}

/** Anzeigename eines Postfachs — der Name, sonst die Adresse. */
export function postfachName(name: string | null | undefined, adresse: string | null | undefined): string {
    return (name ?? "").trim() || (adresse ?? "").trim() || "Postfach";
}

/** Ungelesen-Zahl wie in Outlook: ab 100 „99+", 0 → nichts. */
export function zahlLabel(n: number | null | undefined): string | null {
    if (!n || n <= 0) return null;
    return n > 99 ? "99+" : String(n);
}

/**
 * Zeit im kompakten Mailkopf (Outlook iOS): heute die Uhrzeit, dieses Jahr
 * Tag und Monat, sonst das volle Datum.
 */
export function kurzeZeit(datum: Date, jetzt: Date = new Date()): string {
    if (Number.isNaN(datum.getTime())) return "";
    const zwei = (n: number) => String(n).padStart(2, "0");
    const gleicherTag =
        datum.getFullYear() === jetzt.getFullYear() &&
        datum.getMonth() === jetzt.getMonth() &&
        datum.getDate() === jetzt.getDate();
    if (gleicherTag) return `${zwei(datum.getHours())}:${zwei(datum.getMinutes())}`;
    if (datum.getFullYear() === jetzt.getFullYear()) return `${zwei(datum.getDate())}.${zwei(datum.getMonth() + 1)}.`;
    return `${zwei(datum.getDate())}.${zwei(datum.getMonth() + 1)}.${datum.getFullYear()}`;
}

/** „An …" einzeilig: die Namen (sonst Adressen) der Empfänger. */
export function empfaengerKurz(an: readonly { name?: string | null; address?: string | null }[] | undefined): string {
    const namen = (an ?? []).map((e) => (e.name || e.address || "").trim()).filter(Boolean);
    return namen.length ? `An ${namen.join(", ")}` : "An —";
}
